var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 22.4782C44 34.3393 34.375 43.9563 22.5 43.9563C10.625 43.9563 1 34.3393 1 22.4782C1 10.617 10.625 1 22.5 1C34.375 1 44 10.617 44 22.4782Z",
    stroke: "#43FFBB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9935 16.1809C17.9935 15.4116 18.8268 14.931 19.4937 15.3156L30.9565 21.9273C31.6237 22.3121 31.624 23.2741 30.9571 23.6588L19.4943 30.2704C18.8274 30.6551 17.9935 30.1738 17.9935 29.4042L17.9935 16.1809Z",
    fill: "#FBFBFB"
  })));
}

export default SvgPlay;